<div class="bloco-regiao">
  <div class="dropdown-bloco">
    <div class="custom-dropdown">
      <div class="input-filtro-selecionado">
        <button
          type="button"
          class="dropdown-toggle"
          (click)="mostrarRegioes = !mostrarRegioes"
        >
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/filter.svg"
            width="20"
            height="20"
          />
          {{ regionSelecionada?.regionDescription || "Todas as regiões" }}
        </button>
        <button
          *ngIf="regionSelecionada"
          type="button"
          class="btn-clear"
          (click)="onRegiaoSelecionada(null)"
        >
          ×
        </button>
      </div>
      <div *ngIf="mostrarRegioes" class="dropdown-list">
        <label>
          <input
            type="radio"
            name="regiao"
            [value]="null"
            [checked]="!regionSelecionada"
            (change)="onRegiaoSelecionada(null)"
          />
          Todas
        </label>
        <label *ngFor="let regiao of regions">
          <input
            type="radio"
            name="regiao"
            [value]="regiao"
            [checked]="regionSelecionada?.regionId === regiao.regionId"
            (change)="onRegiaoSelecionada(regiao)"
          />
          {{ regiao.regionDescription }}
        </label>
      </div>
    </div>
  </div>
  <div class="dropdown-bloco">
    <div class="custom-dropdown">
      <div class="input-filtro-selecionado">
        <button
          type="button"
          class="dropdown-toggle"
          (click)="onAbrirEstados()"
        >
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/filter.svg"
            width="20"
            height="20"
          />
          {{ estadoSelecionado?.stateDescription || "Todos os estados" }}
        </button>
        <button
          *ngIf="estadoSelecionado"
          type="button"
          class="btn-clear"
          (click)="limparEstado()"
        >
          ×
        </button>
      </div>
      <div *ngIf="mostrarMsgSelecioneRegiao" class="mensagem-erro-filtro">
        Selecione uma região
      </div>
      <div *ngIf="mostrarEstados" class="dropdown-list">
        <label>
          <input
            type="radio"
            name="estado"
            [value]="null"
            [checked]="!estadoSelecionado"
            (change)="onEstadoSelecionado(null)"
          />
          Todos
        </label>
        <label *ngFor="let estado of states">
          <input
            type="radio"
            name="estado"
            [value]="estado"
            [checked]="estadoSelecionado?.stateId === estado.stateId"
            (change)="onEstadoSelecionado(estado)"
          />
          {{ estado?.stateDescription }}
        </label>
      </div>
    </div>
  </div>

  <div class="dropdown-bloco">
    <div
      class="custom-dropdown"
      [class.disabled]="!estadoSelecionado"
     
    >
      <div class="input-filtro-selecionado">
        <button
         type="button"
      class="dropdown-toggle"
      (click)="onAbrirCidades()"
      [disabled]="!estadoSelecionado"
        >
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/filter.svg"
            width="20"
            height="20"
          />
          {{ cidadesSelecionadasLabel }}
        </button>
        <button
          *ngIf="cidadesSelecionadas.length"
          type="button"
          class="btn-clear"
          (click)="limparCidades()"
        >
          ×
        </button>
      </div>
      <div *ngIf="mostrarMsgSelecioneEstado" class="mensagem-erro-filtro">
        Selecione um estado
      </div>
      <div *ngIf="mostrarCidades" class="dropdown-list">
        <label *ngFor="let cidade of cities">
          <input
            type="checkbox"
            [checked]="cidadesSelecionadas.includes(cidade)"
            (change)="onCidadeChange($event, cidade)"
          />
          {{ cidade.cityDescription }}
        </label>
      </div>
    </div>
  </div>
</div>
